import { defineComponent, computed, ref, watch, createElementBlock, openBlock, normalizeClass, createElementVNode, Fragment, renderList, createVNode, createCommentVNode, mergeProps, withCtx, createTextVNode, toDisplayString, normalizeStyle, createBlock, unref, nextTick } from 'vue';
import { useWindowSize } from './basler-components.es419.js';
import _sfc_main$1 from './basler-components.es134.js';
import _sfc_main$2 from './basler-components.es160.js';
import CloseIcon from './basler-components.es445.js';
import _sfc_main$3 from './basler-components.es133.js';

const _hoisted_1 = ["data-active-level", "data-active-indeces"];
const _hoisted_2 = { class: "nav-main__list nav-main__list--level-1" };
const _hoisted_3 = ["onMouseenter"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "visually-hidden" };
const _hoisted_6 = { class: "nav-main__menu" };
const _hoisted_7 = { class: "nav-main__menu-title-row" };
const _hoisted_8 = { class: "nav-main__level-1-special" };
const _hoisted_9 = { class: "visually-hidden" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MainNavigation",
  props: {
    showTabs: {},
    items: {},
    backButtonLabel: {},
    nextButtonLabel: {},
    closeButtonLabel: {}
  },
  emits: ["menuChange", "isActive", "navigate"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { width } = useWindowSize();
    const isDesktop = computed(() => {
      return width.value >= 1024;
    });
    const activeLevel = ref([]);
    const navWithTabsMinHeight = ref(0);
    watch(
      activeLevel,
      (newVal) => {
        emit("isActive", newVal.length >= 1);
      },
      { immediate: true, deep: true }
    );
    const setActiveLevel = async (level) => {
      activeLevel.value = [level];
      emit("menuChange", true);
      await nextTick();
      calcNavWithTabsMinHeight();
    };
    const unsetActiveLevel = () => {
      activeLevel.value = [];
      emit("menuChange", false);
    };
    const onFirstLevelClick = (event, navigate, index) => {
      if (isDesktop.value) {
        if (activeLevel.value[0] === index) {
          emit("navigate");
          navigate(event);
        } else {
          event.preventDefault();
          setActiveLevel(index);
        }
        return;
      }
      emit("navigate");
      navigate(event);
    };
    const calcNavWithTabsMinHeight = () => {
      const activeItemWithTabsLevel01 = document.querySelector(
        ".nav-main .nav-main__item--level-1.nav-main__item--show-tabs.nav-main__item--has-children.is-active"
      );
      if (activeItemWithTabsLevel01) {
        const subListsLevel03 = activeItemWithTabsLevel01.querySelectorAll(".nav-main__list--level-3");
        if (subListsLevel03?.length) {
          navWithTabsMinHeight.value = Math.max(
            ...Array.from(subListsLevel03).map((subListLevel03) => subListLevel03.clientHeight)
          );
        }
      } else {
        navWithTabsMinHeight.value = 0;
      }
    };
    let mouseLeaveTimer = null;
    let mouseEnterTimer = null;
    const onMouseEnter = (index) => {
      if (!isDesktop.value) {
        return;
      }
      clearTimeout(mouseLeaveTimer);
      if (activeLevel.value.length) {
        setActiveLevel(index);
      } else {
        mouseEnterTimer = setTimeout(() => {
          setActiveLevel(index);
        }, 250);
      }
    };
    const onMouseLeave = () => {
      if (!isDesktop.value) {
        return;
      }
      clearTimeout(mouseEnterTimer);
      mouseLeaveTimer = setTimeout(() => {
        unsetActiveLevel();
      }, 1e3);
    };
    const closeNavigation = () => {
      activeLevel.value = [];
      clearTimeout(mouseLeaveTimer);
    };
    __expose({
      closeNavigation
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", {
        class: normalizeClass(["nav-main", { "nav-main--in-use": activeLevel.value.length > 0 }]),
        "data-active-level": activeLevel.value.length + 1,
        "data-active-indeces": activeLevel.value.join(",")
      }, [
        createElementVNode("ul", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (firstlevelItem, firstlevelIndex) => {
            return openBlock(), createElementBlock("li", {
              class: normalizeClass([
                "nav-main__item",
                "nav-main__item--level-1",
                { "nav-main__item--is-current": firstlevelItem.isActive },
                { "nav-main__item--show-tabs": _ctx.showTabs?.includes(firstlevelIndex) },
                { "nav-main__item--regular": !_ctx.showTabs?.includes(firstlevelIndex) },
                { "nav-main__item--has-children": firstlevelItem.items },
                { "is-active": activeLevel.value[0] === firstlevelIndex }
              ]),
              onMouseenter: ($event) => onMouseEnter(firstlevelIndex),
              onMouseleave: _cache[4] || (_cache[4] = ($event) => onMouseLeave()),
              key: `${firstlevelItem.text}-${firstlevelIndex}`
            }, [
              createVNode(_sfc_main$1, mergeProps({ ref_for: true }, firstlevelItem.link, {
                class: "nav-main__item-link",
                onClick: (event, navigate) => onFirstLevelClick(event, navigate, firstlevelIndex)
              }), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(firstlevelItem.text), 1)
                ]),
                _: 2
              }, 1040, ["onClick"]),
              firstlevelItem.items ? (openBlock(), createElementBlock("button", {
                key: 0,
                type: "button",
                class: "nav-main__next-level",
                onClick: ($event) => activeLevel.value.push(firstlevelIndex)
              }, [
                _cache[5] || (_cache[5] = createElementVNode("span", { class: "nav-main__next-level-arrow" }, null, -1)),
                createElementVNode("span", _hoisted_5, toDisplayString(_ctx.nextButtonLabel), 1)
              ], 8, _hoisted_4)) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_6, [
                createElementVNode("div", {
                  class: "nav-main__menu-inner",
                  style: normalizeStyle(navWithTabsMinHeight.value > 0 ? `--min-height:${navWithTabsMinHeight.value}px` : "")
                }, [
                  createElementVNode("div", _hoisted_7, [
                    createVNode(_sfc_main$1, mergeProps({ ref_for: true }, firstlevelItem.link, {
                      class: "nav-main__item-link",
                      onClick: (event, navigate) => onFirstLevelClick(event, navigate, firstlevelIndex)
                    }), {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(firstlevelItem.altText || firstlevelItem.text), 1)
                      ]),
                      _: 2
                    }, 1040, ["onClick"])
                  ]),
                  _ctx.items ? (openBlock(), createBlock(_sfc_main$2, {
                    key: 0,
                    level: 2,
                    index: firstlevelIndex,
                    parent: firstlevelItem,
                    "active-level": activeLevel.value,
                    "back-button-label": _ctx.backButtonLabel,
                    "next-button-label": _ctx.nextButtonLabel,
                    "set-active-classes": _ctx.showTabs?.includes(firstlevelIndex) || false,
                    onBack: _cache[0] || (_cache[0] = ($event) => activeLevel.value.pop()),
                    onNext: _cache[1] || (_cache[1] = (index) => activeLevel.value.push(index)),
                    onNavigate: _cache[2] || (_cache[2] = ($event) => emit("navigate"))
                  }, null, 8, ["index", "parent", "active-level", "back-button-label", "next-button-label", "set-active-classes"])) : createCommentVNode("", true),
                  createElementVNode("div", _hoisted_8, [
                    firstlevelItem.specialLink ? (openBlock(), createBlock(_sfc_main$3, mergeProps({
                      key: 0,
                      ref_for: true
                    }, firstlevelItem.specialLink.link, {
                      class: "nav-main__item-link",
                      onClick: _cache[3] || (_cache[3] = ($event) => emit("navigate"))
                    }), {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(firstlevelItem.specialLink.text), 1)
                      ]),
                      _: 2
                    }, 1040)) : createCommentVNode("", true),
                    _ctx.closeButtonLabel ? (openBlock(), createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "nav-main__close-button",
                      onClick: unsetActiveLevel
                    }, [
                      createVNode(unref(CloseIcon)),
                      createElementVNode("span", _hoisted_9, toDisplayString(_ctx.closeButtonLabel), 1)
                    ])) : createCommentVNode("", true)
                  ])
                ], 4)
              ])
            ], 42, _hoisted_3);
          }), 128))
        ])
      ], 10, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
